module.exports = __webpack_public_path__ + "static/media/cashAccountSample.8cccd206.xlsx";